// extracted by mini-css-extract-plugin
export default {"sizing":"SizingStart_sizing__MLAeU","sizing__col":"SizingStart_sizing__col__XFA1A","sizingMain":"SizingStart_sizingMain__fR83p","sizingBack":"SizingStart_sizingBack__IN0UJ"};